import { Backdrop, Button, Grid, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAddJob } from "../../../../api/effects/mutations/Job/addJob";
import { useEditJob } from "../../../../api/effects/mutations/Job/editJob";
import { useFetchAdminJob } from "../../../../api/effects/mutations/Job/useFetchAdminJobDetail";
import useFetchAllActiveDivisi from "../../../../api/effects/queries/Divisi/useFetchAllActiveDivisi";
import InputDate from "../../../../components/InputDate";
import InputRadio from "../../../../components/InputRadio";
import InputSelect from "../../../../components/InputSelect";
import InputTextField from "../../../../components/InputTextField";
import { AllDivisiActiveResponse } from "../../../../models/Divisi";
import { convertDate, toIsoStringDate } from "../../../../utils/dateConvert";
import RadioButton from "../../RadioButton";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

const FullButton = styled(Button)(({ theme }) => ({
  marginTop: "3vh",
  marginBottom: "1vh",
  width: "60%",
}));

const ScrollGrid = styled(Grid)(({ theme }) => ({
  overflow: "auto",
  maxHeight: "90vh",
}));

type Props = {
  open: boolean;
  handleClose: () => void;
  ID?: number;
};

export default function JobModal({ ID = -1, open, handleClose }: Props) {
  const [divisi, setDivisi] = useState("");
  const [job, setJob] = useState("");
  const [lokasi, setLokasi] = useState("");
  const [statusKaryawan, setStatusKaryawan] = useState("");
  const [description, setDescription] = useState("");
  const [requirement, setRequirement] = useState("");
  const [qualification, setQualification] = useState("");
  const [tanggalDibuat, setTanggalDibuat] = useState(
    toIsoStringDate(Date.now())
  );
  const [isActive, setIsActive] = useState(false);

  const { data: allActiveDivisiData } = useFetchAllActiveDivisi();

  const [Divisidata, setDivisiData] = useState<AllDivisiActiveResponse[]>([]);

  useEffect(() => {
    if (allActiveDivisiData !== undefined) {
      setDivisiData(allActiveDivisiData);
    }
  }, [allActiveDivisiData]);

  const { mutateAsync: GetJobData } = useFetchAdminJob({
    onSuccess(data) {
      setDivisi(data.DIVISI_ID);
      setJob(data.JOB);
      setLokasi(data.LOKASI);
      setStatusKaryawan(data.STATUS_KARYAWAN);
      setDescription(data.DESCRIPTION);
      setRequirement(data.REQUIREMENT);
      setQualification(data.QUALIFICATION);
      setTanggalDibuat(data.TANGGAL_DIBUAT);
      setIsActive(data.IS_ACTIVE);
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  useEffect(() => {
    if (ID > 0) {
      GetJobData(ID);
    } else {
      setDivisi("");
      setJob("");
      setLokasi("");
      setStatusKaryawan("");
      setDescription("");
      setRequirement("");
      setQualification("");
      setTanggalDibuat(toIsoStringDate(Date.now()));
      setIsActive(false);
    }
  }, [open]);

  const handleDivisi = (e: any) => {
    setDivisi(e.target.value);
  };

  const handleJob = (e: any) => {
    setJob(e.target.value);
  };

  const handleLokasi = (e: any) => {
    setLokasi(e.target.value);
  };

  const handleStatusKaryawan = (e: any) => {
    setStatusKaryawan(e.target.value);
  };

  const handleDescription = (e: any) => {
    setDescription(e.target.value);
  };
  const handleRequirement = (e: any) => {
    setRequirement(e.target.value);
  };

  const handleQualification = (e: any) => {
    setQualification(e.target.value);
  };

  const handleTanggalDibuat = (e: any) => {
    setTanggalDibuat(e);
  };
 const handleIsActive = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsActive(e.target.value === "true");
  };

  const handleSave = () => {
    if (ID > 0) {
      EditJob({
        JOB_ID: ID,
        DIVISI_ID: divisi,
        JOB: job,
        LOKASI: lokasi,
        STATUS_KARYAWAN: statusKaryawan,
        DESCRIPTION: description,
        REQUIREMENT: requirement,
        QUALIFICATION: qualification,
        TANGGAL_DIBUAT: toIsoStringDate(tanggalDibuat),
        IS_ACTIVE: isActive,
      });
    } else {
      AddJob({
        DIVISI_ID: divisi,
        JOB: job,
        LOKASI: lokasi,
        STATUS_KARYAWAN: statusKaryawan,
        DESCRIPTION: description,
        REQUIREMENT: requirement,
        QUALIFICATION: qualification,
        TANGGAL_DIBUAT: toIsoStringDate(tanggalDibuat),
        IS_ACTIVE: isActive,
      });
    }
  };

  const { mutateAsync: AddJob } = useAddJob({
    onSuccess() {
      handleClose();
      setDivisi("");
      setJob("");
      setLokasi("");
      setStatusKaryawan("");
      setDescription("");
      setRequirement("");
      setQualification("");
      setTanggalDibuat("");
      setIsActive(false);
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  const { mutateAsync: EditJob } = useEditJob({
    onSuccess() {
      handleClose();
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <SquareGrid container>
        <ScrollGrid container>
           <Grid container justifyContent="flex-start" paddingLeft={"10.5%"} item xs={6}
            paddingBottom={
              {
                xs: 5,
                sm: 5,
                md: 5,
                lg: 5,
                xl: 5
              }}>
            <Typography variant="subtitle1" color="black">
              {ID === -1 ? "Tambah Job" : "Ubah Job"}
            </Typography>
          </Grid>
          <Grid container justifyContent="flex-end" item xs={6}>
            <Button onClick={handleClose}>Close</Button>
          </Grid>
          <InputSelect
            title={"Divisi"}
            selection={Divisidata}
            value={divisi}
            handleEdit={handleDivisi}
          />
          <InputTextField title={"Job"} value={job} handleEdit={handleJob} />
          <InputTextField
            title={"Lokasi"}
            value={lokasi}
            handleEdit={handleLokasi}
          />

          <InputSelect
            title={"Status Karyawan"}
            selection={[
              { value: "Tetap", text: "Tetap" },
              { value: "Kontrak", text: "Kontrak" },
              { value: "Magang", text: "Magang" },
            ]}
            value={statusKaryawan}
            handleEdit={handleStatusKaryawan}
          />

          <InputTextField
            title={"Description"}
            value={description}
            handleEdit={handleDescription}
          />

          <InputTextField
            title={"Requirement"}
            value={requirement}
            handleEdit={handleRequirement}
          />

          <InputTextField
            title={"Qualification"}
            value={qualification}
            handleEdit={handleQualification}
          />
          <InputDate
            title={"Tanggal Dibuat"}
            value={tanggalDibuat}
            handleEdit={handleTanggalDibuat}
          />
           <RadioButton
            title="Active"
            value={isActive ? "true" : "false"}
            onChange={handleIsActive}
          />
          <Grid container justifyContent="center" item xs={12}>
            <FullButton variant="contained" onClick={handleSave}>
              Save
            </FullButton>
          </Grid>
        </ScrollGrid>
      </SquareGrid>
    </Backdrop>
  );
}
